import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Pagination } from '@mui/material';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, Backdrop, CircularProgress, Autocomplete, Chip, Theme } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import PausePickupHeader from '../pause-pickup/PausePickupHeader';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers';
import debounce from 'lodash.debounce';
import { formatDate } from '../../helpers/custom';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 250,
      },
    },
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
} 


export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchyIds: any;
        selectedHierarchies: any;
    };
}

export interface IState {
    pageSize: number;
    anchorEl: any;
    pause_pickup_data: any[];
    start_date: string | null;
    end_date: string | null;
    community_id: any;
    communities: any;
    page: any;
    rowCount: any;
    showLoader: boolean;
    routes: any;
    currentPage:number
}

class BagInventory extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            pageSize: 10,
            anchorEl: null,
            pause_pickup_data: [],
            start_date: null,
            end_date: null,
            community_id: [],
            currentPage:0,
            communities: [],
            page: 1,
            rowCount: 0,
            showLoader: false,
            routes: [],
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        
        this.fetchPausePickupDate();
        this.fetchRoutes();
    }

    public fetchPausePickupDate(page: any = 0, limit: any = this.state.pageSize){
        this.setState({showLoader: true,currentPage:page});
        let body = {
            "start_date": (this.state.start_date) ? formatDate(this.state.start_date, 'Y-m-d') : "",
            "end_date": (this.state.end_date) ? formatDate(this.state.end_date, 'Y-m-d') : "",
            "hierarchies": this.props.user.selectedHierarchyIds,
            "community_id": this.state.communities?.map((el: any) => el.id),
            "limit": limit
        }
        
        // let page = this.state.page;
        axios.post(`communityUserUnavailabilities?page=${page+1}`, body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                // console.log(response.data.data); 
                let data = response.data.data.data;
                this.setState({rowCount: response.data.data.total, showLoader: false});
                let pauseData = data.map((el:any, index: number) => {
                    return{
                        "id": index+1,
                        "user_id": el.user_id,
                        "users_name": el.users_name,
                        "community_name": el.community_name,
                        "start_date": el.start_date,
                        "end_date": el.end_date,
                        "status": el.is_active,
                        "community_id": el.community_id,
                    }
                })
                this.setState({pause_pickup_data: pauseData});
            } else {
                this.setState({showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchPausePickupDate(page,limit);
      }, 800);

      public fetchRoutes() {
        axios.get(`allCommunitiesLite`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            let data: any = response.data.data;
            // let routes: any = [];
            // data.map((route: any) => {
            //     routes[route.id] = {
            //         id: route.id,
            //         route: route.name,
            //         type: route.type,
                    // hierarchy_id: route.hierarchy_id,
                    // hierarchy_name: route.hierarchy_name,
            //     };
            // });
            this.setState({ routes: data });
        });
    }
    

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);
        const renderMaskedCell = (params: GridCellParams) => (
            <Box
                component="span"
                sx={isUatEnvironment ? {
                    filter: 'blur(4px)',
                    opacity: 0.5,
                    userSelect: 'none',
                } : undefined}
            >
                {params.value}
            </Box>
        );

        const columns = [
            {
                headerName: "ID",
                field: "id",
                width: 100,
                hide: true
            },
            {
                headerName: "User ID",
                field: "user_id",
                width: 100,
            },
            {
                headerName: "Start Date",
                field: "start_date",
                width: 100,
            },
            {
                headerName: "End Date",
                field: "end_date",
                width: 100,
            },
            {
                headerName: "Status",
                field: "status",
                width: 400,
                renderCell: (params: GridCellParams) => (
                    <Typography style={{cursor:'pointer'}}>{params.row.status == 1 ? "Pickups Will Be Paused Between Selected Dates" : ""}</Typography>
                )
            },
            {
                headerName: "Community",
                field: "community_name",
                width: 220,
                renderCell: renderMaskedCell,
            },
            {
                headerName: "User Name",
                field: "users_name",
                width: 200,
                renderCell: renderMaskedCell,
            },
            
        ];


        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <NeighbourhoodHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{height: 600}}>
                            <CardHeader
                                title={<>
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Pause Pickups Details")}</Typography>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <Autocomplete
                                                multiple
                                                id={"Community"}
                                                options={this.state.routes}
                                                size="small"
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                getOptionLabel={(option: any) => option.name}
                                                value={this.state.communities}
                                                onChange={(e: any, value: any) => this.setState({communities: value}, () => this.fetchPausePickupDate())}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={t("Community")}
                                                        placeholder={t("Select Communities")}
                                                    />
                                                )}
                                            />
                                            {/* <Autocomplete
                                                multiple
                                                id="combo-box-demo"
                                                fullWidth={true}
                                                size="small"
                                                limitTags={2}
                                                options={this.state.routes}
                                                value={this.state.communities}
                                                onChange={(value: any, newValue: any) => this.setState({communities: newValue.map((el: any) => el.id)}, () => this.fetchPausePickupDate())}
                                                getOptionLabel={(options: any) => options.name}
                                                renderInput={(params) => <TextField {...params} label="Community" />}
                                            /> */}
                                            {/* <FormControl fullWidth={true} size="small" sx={{maxWidth: '100%' }}>
                                                <InputLabel id="demo-multiple-chip-label">Communities</InputLabel>
                                                <Select
                                                    labelId="routes-select-label"
                                                    multiple
                                                    value={this.state.communities}
                                                    onChange={(e) => this.setState({ communities: e.target.value }, () => this.fetchPausePickupDate())}
                                                    input={<OutlinedInput id="select-multiple-chip" label="Communities" />}
                                                    renderValue={(selected) => (
                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                            {selected.slice(0, 2).map((value: any, key: any) => (
                                                                <Chip key={key} label={value.route} />
                                                            ))}
                                                              {selected.length > 2 && <Typography style={{ marginTop: '4px' }}>{" +"}{selected.length - 2}</Typography>}
                                                        </Box>
                                                    )}
                                                    MenuProps={MenuProps}
                                                    displayEmpty
                                                    label={t("Communities")}
                                                    fullWidth={true}
                                                >
                                                    {
                                                        this.state.routes.map((route: any, key: any) => {
                                                            return <MenuItem key={key} value={route}>{route.route}</MenuItem>;
                                                        })
                                                    }
                                                </Select>
                                            </FormControl> */}

                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="yyyy-MM-dd"
                                                        views={['year', 'month', 'day']}
                                                        mask="____-__-__"
                                                        renderInput={(props) => <TextField {...props} size="small"/>}
                                                        label={t("Start Date")}
                                                        value={this.state.start_date}
                                                        onChange={(newValue: any) => {
                                                            this.setState({ start_date: newValue });
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="yyyy-MM-dd"
                                                        views={['year', 'month', 'day']}
                                                        mask="____-__-__"
                                                        renderInput={(props) => <TextField {...props} size="small"/>}
                                                        label={t("End Date")}
                                                        value={this.state.end_date}
                                                        onChange={(newValue: any) => {
                                                            this.setState({ end_date: newValue });
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <Button variant='contained' onClick={() => this.fetchPausePickupDate()}>Filter By Date</Button>
                                        </Grid>
                                    </Grid>
                                </>
                                }
                                className="text-left"
                            // action={
                            //     <CardActions>
                            //         <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAgent: true })}>
                            //             Delete Bags Permanently
                            //         </Button>
                            //         <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAgent: true })}>
                            //             Delete Bags Permanently
                            //         </Button>
                            //         <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAgent: true })}>
                            //             Delete Bags Permanently
                            //         </Button>
                            //     </CardActions>
                            // }
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label="List of Barcoded Bags"
                                    columns={columns}
                                    rows={this.state.pause_pickup_data}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchPausePickupDate(page)}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize }, () => this.fetchPausePickupDate(0, newPageSize))}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{ height: 500, minWidth: '100%', overflowX: 'auto' }}
                                    pagination
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchPausePickupDate(page-1)}
                                                
                                            />
                                        )
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/neighbourhood/customers/' + params.row.user_id)
                                    }}
                                    className="clickableList"
                                    paginationMode="server"

                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(BagInventory))
